<template lang="html">

  <section class="section">

    <HeaderSection :title="name || $t('components.progressGroupAgility.agility')">
    </HeaderSection>

    <div class="section-content">
      <Label
        :qty="replicated"
        :label="$t('components.progressGroupAgility.form.replicated')"/>
      <Label
        :total="vms.total"
        :qty="vms.running"
        :tooltipText="c('agility')"
        :label="$t('components.progressGroupAgility.form.running')"/>
    </div>

    <div class="section-content">

      <ProgressStandalone
        :total="cpu.total"
        :value="cpu.running"
        :label="$t('components.progressGroupAgility.form.cpu')"
        :unit="$t('components.progressGroupAgility.form.cpu')"
        color="delta"/>

      <ProgressStandalone
        :total="memory.total"
        :value="memory.running"
        :label="$t('components.progressGroupAgility.form.memory')"
        :unit="$t('components.progressGroupAgility.form.gb')"
        color="gamma"/>

      <ProgressStandalone
        :total="storage.total"
        :value="storage.running"
        :label="$t('components.progressGroupAgility.form.storage')"
        :unit="$t('components.progressGroupAgility.form.gb')"
        color="alpha"/>

      <router-link v-if="!hideProblems" class="progress" :to="{ name: 'agilityMonitoring', params: { locale: $i18n.locale } }">
        <ProgressStandalone
          :value="problems"
          :label="$t('components.progressGroupAgility.form.problem')"
          :unit="problemsLabel"
          color="gamma"/>
      </router-link>

  </div>

</section>

</template>

<script lang="js">

import HeaderSection from '@/components/HeaderSection.vue';
import Label from '@/components/Label.vue';
import ProgressStandalone from '@/components/ProgressStandalone.vue';

export default {
  name: 'ProgressGroupAgility',
  components: {
    HeaderSection,
    Label,
    ProgressStandalone,
  },
  props: {
    name: {
      type: String,
      required: false
    },
    replicated: {
      type: Number,
      required: true,
    },
    vms: {
      type: Object,
      required: true,
    },
    cpu: {
      type: Object,
      required: true,
    },
    memory: {
      type: Object,
      required: true,
    },
    storage: {
      type: Object,
      required: true,
    },
    problems: {
      type: Number,
      required: false,
      default: 0,
    },
    hideProblems: {
      type: Boolean,
      required: false
    }
  },
  mounted() {

  },
  data() {
    return {
    };
  },
  methods: {

  },
  computed: {
    problemsLabel() {
      return (this.problems > 1) ? this.$t('components.progressGroupAgility.form.problems') : this.$t('components.progressGroupAgility.form.problem');
    },
  },
};
</script>

<style scoped lang="scss">
</style>
